import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {HeadCounsellorService} from '../../../shared/services/head-counsellor.service';
import {UniversityService} from '../../../shared/services/university.service';
import {StateService} from '../../../shared/services/state.service';

@Component({
    selector: 'app-add-head-counsellor',
    templateUrl: './add-head-counsellor.component.html',
    styleUrls: ['./add-head-counsellor.component.scss']
})
export class AddHeadCounsellorComponent implements OnChanges, OnInit {
    addHeadCounsellorForm: FormGroup;
    id: any;
    universities: any = [];
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    states: any = [];
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                private headCounsellorService: HeadCounsellorService,
                private universityService: UniversityService,
                private stateService: StateService) {
    }

    ngOnInit(): void {
        this.getStates();
    }

    ngOnChanges(): void {
        this.refresh();

    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-head-counsellor').toggleOpen();
    }

    refresh() {
        this.addHeadCounsellorForm = this.fb.group({
            'name': ['', Validators.required],
            'username': ['', (!this.id) ? Validators.required : ''],
            'email': ['', Validators.compose([Validators.required, Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
            'contact': ['', Validators.compose([Validators.required, Validators.pattern('^[5-9]{1}[0-9]{9}$')])],
            'password': ['', (!this.data || !this.data['id']) ? Validators.required : ''],
            'address': ['', (!this.id) ? Validators.required : ''],
            'state_id': [''],
            'pin': ['', (!this.id) ? Validators.required : ''],
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
        this.getUniversityId();
    }

    patchForm() {
        this.addHeadCounsellorForm.patchValue({
            'name': (this.data && this.data && this.data['user'] && this.data['user']['name']) ? this.data['user']['name'] : '',
            'username': (this.data && this.data['user'] && this.data['user']['username']) ? this.data['user']['username'] : '',
            'email': (this.data && this.data['user'] && this.data['user']['email']) ? this.data['user']['email'] : '',
            'contact': (this.data && this.data['user'] && this.data['user']['contact']) ? this.data['user']['contact'] : '',
            'address': (this.data && this.data['address']) ? this.data['address'] : '',
            'state_id': (this.data && this.data['state_id']) ? this.data['state_id'] : '',
            'pin': (this.data && this.data['pin']) ? this.data['pin'] : '',
        });
    }

    getUniversityId() {
        this.universityService.get(this.data).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.universities = data['data'];
            }
        });
    }

    getStates() {
        this.stateService.get().subscribe(data => {
            if (data && data['data'].length > 0) {
                this.states = data['data'];
            }
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addHeadCounsellorForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.name) ? this.addHeadCounsellorForm.value.name : '',
                'username': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.username) ? this.addHeadCounsellorForm.value.username : '',
                'email': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.email) ? this.addHeadCounsellorForm.value.email : '',
                'contact': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.contact) ? this.addHeadCounsellorForm.value.contact : '',
                'password': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.password) ? this.addHeadCounsellorForm.value.password : '',
                'address': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.address) ? this.addHeadCounsellorForm.value.address : '',
                'state_id': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.state_id) ? this.addHeadCounsellorForm.value.state_id : '',
                'pin': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.pin) ? this.addHeadCounsellorForm.value.pin : '',
            };
            this.submitting = true;
            this.headCounsellorService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addHeadCounsellorForm.reset();
                    this.addHeadCounsellorForm.patchValue({
                        'name': '',
                        'username': '',
                        'email': '',
                        'contact': '',
                        'password': '',
                        'address': '',
                        'state_id': '',
                        'pin': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addHeadCounsellorForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.name) ? this.addHeadCounsellorForm.value.name : '',
                'username': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.username) ? this.addHeadCounsellorForm.value.username : '',
                'email': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.email) ? this.addHeadCounsellorForm.value.email : '',
                'contact': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.contact) ? this.addHeadCounsellorForm.value.contact : '',
                'address': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.address) ? this.addHeadCounsellorForm.value.address : '',
                'state_id': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.state_id) ? this.addHeadCounsellorForm.value.state_id : '',
                'pin': (this.addHeadCounsellorForm.value && this.addHeadCounsellorForm.value.pin) ? this.addHeadCounsellorForm.value.pin : '',
            };
            this.submitting = true;
            this.headCounsellorService.update(this.data['user']['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }
}
